import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgTriangleExclamation = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M20.806 17.66 13.307 4.863a1.49 1.49 0 0 0-1.3-.738c-.507 0-1.013.246-1.333.738L3.179 17.66c-.545.981.174 2.215 1.33 2.215h14.997c1.152 0 1.873-1.23 1.3-2.215m-15.951.527 7.12-12.206 7.182 12.207zm7.151-3.336a1.105 1.105 0 1 0 0 2.211 1.105 1.105 0 0 0 0-2.21m-.844-5.382v3.375a.844.844 0 0 0 1.688 0V9.469a.844.844 0 0 0-1.687 0"
    }));
export default SvgTriangleExclamation;
